import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplicationProcessApi from 'api/curo/ApplicationProcessApi';
import { ApplicationProcessActionTypes } from 'enums/curo/ApplicationProcessActionTypes';

export const createPlaidSavePublicTokenThunk = (api: ApplicationProcessApi) =>
  createAsyncThunk(
    ApplicationProcessActionTypes.PlaidIdentityMatch,
    async (publicToken: string) => {
      const response = await api.plaidSavePublicToken(publicToken);
      return response;
    },
  );
